import moment from 'moment'

export const formatDatetime = function (value) {
  if (!value) return value
  return moment(value).format('LLL')
}
